<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  isCheckMode: boolean;
  isLoading: boolean;
  title: string;
}>();

const emit = defineEmits<{
  close: [];
}>();
</script>

<template>
  <header
    class="check-asset-panel__header d-flex align-center justify-space-between flex-grow-0 px-4 py-3 border-b border-color-line-border">
    <div class="d-flex align-center gap-4 text-truncate me-2">
      <v-icon
        v-if="!isCheckMode"
        size="28"
        class="flex-shrink-0 text-high-emphasis"
        icon="mdi-truck-trailer" />
      <span class="typography-heading-lg-bold text-truncate">
        {{ isCheckMode ? t('assetCheckWizard.title') : isLoading ? '—' : title }}
      </span>
    </div>
    <v-btn
      icon
      variant="text"
      size="small"
      class="flex-shrink-0"
      :aria-label="t('global.basicTerms.close')"
      data-testid="check-asset-panel-close-btn"
      @click="emit('close')">
      <v-icon icon="mdi-close" />
    </v-btn>
  </header>
</template>

<style scoped lang="scss">
.check-asset-panel__header {
  min-block-size: $spacing-16;
}
</style>
